import React from 'react';

const EmptyAgenda = ({ text }) => {

	return (
		<div className="empty-state  flow">
			<figure className="empty-state__figure" style={{ '--aspect-ratio': `1/1` }}>
				<svg version="1.1" viewBox="0 0 160 160" focusable="false">
					<path
					fill="currentColor"
					d="M49.41,87.89,55,82.3l-5.58-5.58a5.93,5.93,0,0,1,8.37-8.39l5.59,5.59L69,68.33a5.92,5.92,0,1,1,8.37,8.38L71.75,82.3l5.58,5.59A5.93,5.93,0,0,1,69,96.27l-5.58-5.59-5.58,5.59a5.93,5.93,0,1,1-8.38-8.38ZM95.06,28.56a6.09,6.09,0,0,1-6-5.91V6.91a6,6,0,0,1,11.94,0V22.65A6.09,6.09,0,0,1,95.06,28.56Zm-63.37,0a6.09,6.09,0,0,1-6-5.91V6.91a6,6,0,0,1,11.94,0V22.65A6.09,6.09,0,0,1,31.69,28.56ZM160,150.79,140,131a31,31,0,0,0-13.64-44.27l.4.18V22.57a6.1,6.1,0,0,0-5.94-5.95H108.92v5.95a13.86,13.86,0,1,1-27.72,0V16.62H45.55v5.95a14.06,14.06,0,0,1-13.86,13.9,14.06,14.06,0,0,1-13.87-13.9V16.62H5.94A6.1,6.1,0,0,0,0,22.57v99.25a6.09,6.09,0,0,0,5.94,6h80.6c-.07-.16-.13-.33-.2-.49a30.36,30.36,0,0,0,27.77,18.28,30,30,0,0,0,18.11-6.06L151.87,159ZM125.64,86.38l-.67-.27ZM121.35,85l-.72-.16Zm2.89.88-.69-.24Zm-1.43-.47c-.23-.08-.47-.14-.71-.21C122.34,85.23,122.58,85.29,122.81,85.37ZM83.72,114.82c0,.44,0,.87,0,1.3,0-.1,0-.19,0-.29H11.94V48.31H114.81V84.09l.42,0c-.37,0-.74,0-1.12,0A30.57,30.57,0,0,0,83.72,114.82ZM86,126.59l-.27-.69Zm-.54-1.41c-.08-.23-.15-.47-.23-.7C85.34,124.71,85.41,125,85.49,125.18ZM85,123.74c-.07-.24-.13-.48-.2-.72C84.89,123.26,85,123.5,85,123.74Zm-.4-1.47c-.06-.25-.11-.49-.16-.74C84.51,121.78,84.56,122,84.62,122.27Zm-.32-1.5c0-.25-.1-.5-.14-.75C84.2,120.27,84.25,120.52,84.3,120.77ZM84,119.24c0-.25-.07-.51-.1-.76C84,118.73,84,119,84,119.24Zm-.18-1.55c0-.25,0-.51-.06-.77C83.82,117.18,83.83,117.44,83.86,117.69Zm36-33-.74-.14Zm-1.52-.26-.75-.09Zm-1.54-.17c-.25,0-.51,0-.76-.06C116.29,84.16,116.55,84.18,116.8,84.21ZM93.65,114.82a20.46,20.46,0,1,1,20.46,20.81A20.64,20.64,0,0,1,93.65,114.82Z"
					/>
				</svg>
			</figure>

			<div className="empty-state__body ">
				<div className="empty-state__copy">
					{text}
				</div>
			</div>
		</div>
	);
}

export default EmptyAgenda;
